import React from 'react'
import { Input, Select, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select

const ReminderFilters = ({ filterValues, filterState }) => {
  const {
    searchText,
    setSearchText,
    categoryFilter,
    setCategoryFilter,
    priorityFilter,
    setPriorityFilter,
    acknowledgedFilter,
    setAcknowledgedFilter
  } = filterState

  const { categories, priorities } = filterValues

  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search reminders'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 250 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Category'
        style={{ width: 180 }}
        value={categoryFilter}
        onChange={(value) => setCategoryFilter(value)}
      >
        <Option value='all'>All Categories</Option>
        {categories.map((category) => (
          <Option key={category} value={category}>
            {category}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Priority'
        style={{ width: 150 }}
        value={priorityFilter}
        onChange={(value) => setPriorityFilter(value)}
      >
        <Option value='all'>All Priorities</Option>
        {priorities.map((priority) => (
          <Option key={priority} value={priority}>
            {priority}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 180 }}
        value={acknowledgedFilter}
        onChange={(value) => setAcknowledgedFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        <Option value='acknowledged'>Acknowledged</Option>
        <Option value='unacknowledged'>Unacknowledged</Option>
      </Select>
    </div>
  )
}

export default ReminderFilters
